import { render, staticRenderFns } from "./onHuov.vue?vue&type=template&id=a4c781ae&scoped=true"
import script from "./onHuov.vue?vue&type=script&lang=js"
export * from "./onHuov.vue?vue&type=script&lang=js"
import style0 from "./onHuov.vue?vue&type=style&index=0&id=a4c781ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c781ae",
  null
  
)

export default component.exports